import React, { useEffect, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import classNames from 'classnames/bind';
import styles from './KinhDich.module.scss';
import { Box, Button, Container, Grid, Stack } from '@mui/material';
import {
  Diversity2,
  InfoOutlined,
  KeyboardDoubleArrowDownOutlined,
  KeyboardDoubleArrowUpOutlined,
} from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { fromPrettyParam, toPrettyParam } from '../../../utils/helper';
import { getSimBatCuc } from '../../../services/listSim';
import KinhDichDetail from './KinhDichDetail';
import { split } from 'lodash-es';

const cx = classNames.bind(styles);

// chuẩn hóa tên class
const normalizeClass = (text) =>
  text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '-')
    .replace(/[^a-zA-Z0-9-]/g, '');

const groups = [
  {
    title: 'Phát Triển Cá Nhân',
    doiTuong: ['Sim Sinh Viên', 'Sim Cầu Học', 'Sim Cầu Danh'],
    truTruong: ['Sinh Khí', 'Diên Niên', 'Ngũ Quỷ'],
  },
  {
    title: 'Tài Lộc – Giữ Tiền',
    doiTuong: ['Sim Cầu Tài', 'Sim Giữ Tiền'],
    truTruong: ['Thiên Y', 'Phục Vị', 'Sinh Khí', 'Diên Niên'],
  },
  {
    title: 'Gia Đạo – Hôn Nhân',
    doiTuong: ['Sim Kích Cưới', 'Sim Chung Thủy', 'Sim Cầu Con'],
    truTruong: ['Diên Niên', 'Thiên Y', 'Phục Vị'],
  },
  {
    title: 'Sức Khỏe – Sắc Đẹp',
    doiTuong: ['Sim Người Lớn Tuổi', 'Sim Trợ Sắc Đẹp'],
    truTruong: ['Thiên Y', 'Diên Niên', 'Sinh Khí', 'Lục Sát'],
  },
  {
    title: 'Trí Tuệ',
    doiTuong: ['Bác sĩ', 'kỹ sư', 'IT', 'thiết kế', 'giáo viên', 'nghiên cứu'],
    truTruong: ['Ngũ Quỷ', 'Thiên Y'],
  },
  {
    title: 'Khẩu Tài (Giao tiếp ra tiền)',
    doiTuong: ['Bán hàng', 'MC', 'Luật sư', 'Môi giới', 'Diễn giả', 'Tư vấn'],
    truTruong: ['Họa Hại', 'Thiên Y'],
  },
  {
    title: 'Dịch Vụ – Phục Vụ',
    doiTuong: ['Spa', 'Thẩm mỹ', 'Chăm sóc khách hàng', 'Điều dưỡng', 'Phục vụ'],
    truTruong: ['Lục Sát', 'Thiên Y'],
  },
  {
    title: 'Đầu Tư – Kinh Doanh',
    doiTuong: ['BDS', 'Chứng khoán', 'Startup', 'Tài chính', 'Kinh doanh tự do'],
    truTruong: ['Tuyệt Mệnh', 'Thiên Y'],
  },
  {
    title: 'Tâm Linh – Phong Thủy',
    doiTuong: ['Phong thủy', 'Tarot', 'Chữa lành', 'Thiền', 'Huyền học'],
    truTruong: ['Tuyệt Mệnh', 'Lục Sát', 'Sinh Khí'],
  },
  {
    title: 'Công Nhân – Viên Chức',
    doiTuong: ['Công chức', 'Hành chính', 'Kế toán', 'Giáo vụ', 'Kỹ thuật viên'],
    truTruong: ['Phục Vị', 'Sinh Khí', 'Diên Niên', 'Thiên Y'],
  },
  {
    title: 'Quý Nhân Khai Lộc',
    doiTuong: ['Đầu Tư – Kinh Doanh', 'Dịch Vụ – Phục Vụ'],
    truTruong: ['Sinh Khí', 'Thiên Y'],
  },
  { title: 'Cầu Quan', doiTuong: ['Công Nhân – Viên Chức', 'Trí Tuệ'], truTruong: ['Sinh Khí', 'Diên Niên'] },
];

export default function SimJobGroups() {
  const hostname = window.location.hostname;
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const prNN = urlParams.get('nn');
  const mangSim = urlParams.get('mang') || '';
  const rangeSim = urlParams.get('range') || '';
  const bySim = urlParams.get('by') || '';
  const checkUrlNgheNghiep = location.pathname === '/sim-theo-nghe-nghiep' ? true : false;
  const [isNgheNgiep, setIsNgheNgiep] = useState(prNN === null ? false : checkUrlNgheNghiep ? true : false);
  const [selected, setSelected] = useState([]);
  const navigate = useNavigate();
  const toggleSelect = (idx) => {
    setSelected((prev) => {
      if (prev.includes(idx)) {
        return prev.filter((i) => i !== idx);
      }
      if (prev.length >= 3) {
        return prev; // nếu đã đủ 3 thì không thêm nữa
      }
      return [...prev, idx];
    });
  };

  const textDuNien = (selected) => {
    const arrDuNien = [...new Set(selected.flatMap((idx) => groups[idx].truTruong))].join();
    return arrDuNien;
  };

  const subDuNien = () => {
    navigate(`/sim-theo-nghe-nghiep?nn=${selected.join()}`, { replace: true });
    window.location.reload();
  };

  const getSelectNghe = (selected) => {
    if (selected.length > 0) {
      const nghe = selected.map((idx) => groups[idx].title);
      return nghe.join();
    }
    return null;
  };
  const checkParam = () => {
    if (prNN) {
      setSelected(prNN?.split(',')?.map(Number));
    }
  };

  useEffect(() => {
    if (prNN) {
      checkParam();
    }
  }, [prNN]);

  return (
    <Grid item xs={12} md={12}>
      <Container sx={{ p: 0 }} maxWidth="lg">
        <div className={cx('bgt', 'sim-title-dn', 'flex-end', 'mb-20')}>
          <div className={cx('l1')}></div>
          <div className={cx('l2')}></div>
          <div className={cx('r1')}></div>
          <div className={cx('r2')}></div>
          {isNgheNgiep && prNN ? (
            <span>
              Sim theo: <br /> <span className={cx('color-red-son')}>{getSelectNghe(selected)}</span>
            </span>
          ) : (
            'Phong Thủy Theo Nghề Nghiệp'
          )}
        </div>
        {isNgheNgiep ? (
          <Box className={cx('bgr-trang-job')}>
            <Stack direction={'row'} justifyContent={'space-between'} sx={{ mb: 1 }}>
              {' '}
              <p className={cx('flex', 'color-green-son', 'size-16')}>
                <Diversity2 className={cx('font-size-24')} />
                <b>
                  {' '}
                  DANH SÁCH TÌM KIẾM SIM THEO NHÓM NGÀNH NGHỀ ({selected.length}
                  /3)
                </b>
              </p>
              <Button
                variant="outlined"
                sx={{ borderRadius: 5 }}
                color="error"
                onClick={() => setIsNgheNgiep(!isNgheNgiep)}
                size="small"
              >
                <KeyboardDoubleArrowDownOutlined />
              </Button>
            </Stack>
          </Box>
        ) : (
          <Box className={cx('bgr-trang-job')}>
            <Stack direction={'row'} justifyContent={'space-between'} sx={{ mb: 1 }}>
              {' '}
              <p className={cx('flex', 'size-14', 'color-green-son')}>
                <InfoOutlined className={cx('font-size-24')} />{' '}
                <b>
                  Chọn tối đa 3 nhóm phù hợp với bạn để tìm sim phù hợp ({selected.length}
                  /3)
                </b>
              </p>
              <Button
                variant="outlined"
                sx={{ borderRadius: 5 }}
                color="success"
                onClick={() => setIsNgheNgiep(!isNgheNgiep)}
                size="small"
              >
                <KeyboardDoubleArrowUpOutlined />
              </Button>
            </Stack>
            <Grid container spacing={2} alignItems="stretch">
              {groups.map((g, idx) => {
                const isActive = selected.includes(idx);
                const isDisabled = !isActive && selected.length >= 3;
                return (
                  <Grid item key={idx} xs={12} md={4} sx={{ display: 'flex' }}>
                    <div
                      className={cx('sim-card', { active: isActive, disabled: isDisabled })}
                      onClick={() => toggleSelect(idx)}
                      style={{ width: '100%' }}
                    >
                      <div className={cx('sim-header')}>
                        <input type="checkbox" id={`chk-${idx}`} checked={isActive} readOnly />
                        <label htmlFor={`chk-${idx}`} className={cx('sim-label')}>
                          {g.title}
                        </label>
                      </div>

                      <div className={cx('sim-body')}>
                        <div className={cx('sim-section')}>
                          <p className={cx('sim-section-title')}>Đối tượng:</p>
                          <div className={cx('sim-tags')}>
                            {g.doiTuong.map((d, i) => (
                              <span key={i} className={cx('sim-tag')}>
                                {d}
                              </span>
                            ))}
                          </div>
                        </div>

                        <div className={cx('sim-section')}>
                          <p className={cx('sim-section-title')}>Từ trường:</p>
                          <div className={cx('sim-tags')}>
                            {g.truTruong.map((t, i) => (
                              <span key={i} className={cx('sim-tag', `energy-${normalizeClass(t)}`)}>
                                {t}
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Grid>
                );
              })}
            </Grid>

            <div className={cx('mt-20', `${selected.length > 0 ? 'fix' : ''}`)}>
              <Stack direction={'row'} justifyContent={'space-between'} sx={{ mb: 1 }}>
                {' '}
                <h3 className={cx('summary-title')}>Nhóm đã chọn ({selected.length}/3): </h3>{' '}
                <button className={cx('btn-reset')} onClick={() => setSelected([])}>
                  Đặt lại
                </button>
              </Stack>
              {selected.length > 0 && (
                <div>
                  <div className={cx('summary-section')}>
                    <p className={cx('summary-subtitle')}>Từ trường được ưu tiên:</p>
                    <div className={cx('summary-tags')}>
                      {[...new Set(selected.flatMap((idx) => groups[idx].truTruong))].map((t, i) => (
                        <span key={i} className={cx('sim-tag', `energy-${normalizeClass(t)}`)}>
                          {t}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className={cx('summary-section')}>
                    <p className={cx('summary-subtitle')}>Ngành nghề được lọc:</p>
                    <div className={cx('summary-tags')}>
                      {selected.map((idx) => (
                        <span key={idx} className={cx('summary-tag')}>
                          {groups[idx].title}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              )}
              <div className={cx('summary-actions', 'mt-20')}>
                <button
                  className={cx('btn-apply', 'flex-center', 'w-full')}
                  onClick={() => {
                    subDuNien();
                  }}
                >
                  <SearchIcon /> Áp Dụng Bộ Lọc Theo Nghề Nghiệp
                </button>
              </div>
            </div>
          </Box>
        )}
        {selected.length > 0 && (
          <KinhDichDetail
            diennien={textDuNien(selected)}
            orderBy={bySim === '1' ? 'ASC' : bySim === '2' ? 'DESC' : ''}
            nhamang={mangSim}
            RangePrice={rangeSim}
            nghenghiep={prNN}
          />
        )}
      </Container>
    </Grid>
  );
}
